import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
  ) {}

  showSuccess(message: string) {
    return this.snackBar.open(message, undefined, { duration: 5000, panelClass: 'snackbar-success' });
  }

  showError(message: string) {
    return this.snackBar.open(message, this.translateService.instant('LABEL.CLOSE'), { panelClass: 'snackbar-error' });
  }

  showInfo(message: string) {
    return this.snackBar.open(message, this.translateService.instant('LABEL.CLOSE'), {
      duration: 5000,
      panelClass: 'snackbar-info',
    });
  }
}
